import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _ComposerService_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import EmberObject, { action, computed } from "@ember/object";
import { alias, and, or, reads } from "@ember/object/computed";
import { cancel, scheduleOnce } from "@ember/runloop";
import Service, { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import { isEmpty } from "@ember/utils";
import { observes, on } from "@ember-decorators/object";
import $ from "jquery";
import { Promise } from "rsvp";
import DiscardDraftModal from "discourse/components/modal/discard-draft";
import PostEnqueuedModal from "discourse/components/modal/post-enqueued";
import SpreadsheetEditor from "discourse/components/modal/spreadsheet-editor";
import { categoryBadgeHTML } from "discourse/helpers/category-link";
import { cannotPostAgain, durationTextFromSeconds } from "discourse/helpers/slow-mode";
import { customPopupMenuOptions } from "discourse/lib/composer/custom-popup-menu-options";
import prepareFormTemplateData, { getFormTemplateObject } from "discourse/lib/form-template-validation";
import { shortDate } from "discourse/lib/formatter";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
import { buildQuote } from "discourse/lib/quote";
import renderTags from "discourse/lib/render-tags";
import { emojiUnescape } from "discourse/lib/text";
import { authorizesOneOrMoreExtensions, uploadIcon } from "discourse/lib/uploads";
import DiscourseURL from "discourse/lib/url";
import { escapeExpression, modKeysPressed } from "discourse/lib/utilities";
import Category from "discourse/models/category";
import Composer, { CREATE_TOPIC, NEW_TOPIC_KEY, SAVE_ICONS, SAVE_LABELS } from "discourse/models/composer";
import Draft from "discourse/models/draft";
import { isTesting } from "discourse-common/config/environment";
import discourseDebounce from "discourse-common/lib/debounce";
import deprecated from "discourse-common/lib/deprecated";
import { getOwnerWithFallback } from "discourse-common/lib/get-owner";
import getURL from "discourse-common/lib/get-url";
import { iconHTML } from "discourse-common/lib/icon-library";
import discourseComputed from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
async function loadDraft(store) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let {
    draft,
    draftKey,
    draftSequence
  } = opts;
  try {
    if (draft && typeof draft === "string") {
      draft = JSON.parse(draft);
    }
  } catch (error) {
    draft = null;
    Draft.clear(draftKey, draftSequence);
  }
  if (!draft?.title && !draft?.reply) {
    return;
  }
  let attrs = {
    draftKey,
    draftSequence,
    draft: true,
    composerState: Composer.DRAFT,
    topic: opts.topic
  };
  Composer.serializedFieldsForDraft().forEach(f => {
    attrs[f] = draft[f] || opts[f];
  });
  const composer = store.createRecord("composer");
  await composer.open(attrs);
  return composer;
}
const _composerSaveErrorCallbacks = [];
let _checkDraftPopup = !isTesting();
export function toggleCheckDraftPopup(enabled) {
  _checkDraftPopup = enabled;
}
export function clearComposerSaveErrorCallback() {
  _composerSaveErrorCallbacks.length = 0;
}
export function addComposerSaveErrorCallback(callback) {
  _composerSaveErrorCallbacks.push(callback);
}
let ComposerService = (_dec = and("site.mobileView", "showPreview"), _dec2 = or("isWhispering", "model.unlistTopic"), _dec3 = alias("site.categoriesList"), _dec4 = alias("topicController.model"), _dec5 = reads("currentUser.staff"), _dec6 = reads("currentUser.whisperer"), _dec7 = and("model.creatingTopic", "isStaffUser"), _dec8 = or("replyingToWhisper", "model.whisper"), _dec9 = on("init"), _dec10 = computed("model.loading", "isUploading", "isProcessingUpload", "_disableSubmit"), _dec11 = computed("model.category", "skipFormTemplate"), _dec12 = discourseComputed("showPreview"), _dec13 = observes("showPreview"), _dec14 = discourseComputed("model.replyingToTopic", "model.creatingPrivateMessage", "model.targetRecipients", "model.composeState"), _dec15 = discourseComputed("model.canEditTitle", "model.creatingPrivateMessage"), _dec16 = discourseComputed("model.editingPost", "model.topic.details.can_edit"), _dec17 = discourseComputed("model.editingPost", "model.topic.canEditTags"), _dec18 = discourseComputed("canWhisper", "replyingToWhisper"), _dec19 = discourseComputed("model.post"), _dec20 = discourseComputed("model.action", "isWhispering", "model.privateMessage"), _dec21 = discourseComputed("model.action", "isWhispering", "model.editConflict", "model.privateMessage", "model.tags", "model.category"), _dec22 = discourseComputed("whisperer", "model.action"), _dec23 = discourseComputed("model.requiredCategoryMissing", "model.replyLength"), _dec24 = discourseComputed("model.composeState", "model.creatingTopic", "model.post"), _dec25 = discourseComputed("model.creatingPrivateMessage", "model.targetRecipients", "model.warningsDisabled"), _dec26 = discourseComputed("model.topic.title"), _dec27 = discourseComputed(), _dec28 = discourseComputed("model.action", "isWhispering", "model.privateMessage", "model.post.username"), _dec29 = observes("model.reply", "model.title"), _dec30 = discourseComputed("model.categoryId", "lastValidatedAt"), _dec31 = discourseComputed("model.category", "model.tags", "lastValidatedAt"), _dec32 = discourseComputed("model.viewFullscreen", "model.showFullScreenExitPrompt"), _dec33 = discourseComputed("model.action"), _dec34 = discourseComputed("model.composeState"), disableImplicitInjections(_class = (_class2 = (_ComposerService_brand = /*#__PURE__*/new WeakSet(), class ComposerService extends Service {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _ComposerService_brand);
    _initializerDefineProperty(this, "appEvents", _descriptor, this);
    _initializerDefineProperty(this, "capabilities", _descriptor2, this);
    _initializerDefineProperty(this, "currentUser", _descriptor3, this);
    _initializerDefineProperty(this, "dialog", _descriptor4, this);
    _initializerDefineProperty(this, "keyValueStore", _descriptor5, this);
    _initializerDefineProperty(this, "messageBus", _descriptor6, this);
    _initializerDefineProperty(this, "modal", _descriptor7, this);
    _initializerDefineProperty(this, "router", _descriptor8, this);
    _initializerDefineProperty(this, "site", _descriptor9, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor10, this);
    _initializerDefineProperty(this, "store", _descriptor11, this);
    _defineProperty(this, "checkedMessages", false);
    _defineProperty(this, "messageCount", null);
    _defineProperty(this, "showEditReason", false);
    _defineProperty(this, "editReason", null);
    _defineProperty(this, "scopedCategoryId", null);
    _defineProperty(this, "prioritizedCategoryId", null);
    _defineProperty(this, "lastValidatedAt", null);
    _defineProperty(this, "isUploading", false);
    _defineProperty(this, "isProcessingUpload", false);
    _defineProperty(this, "topic", null);
    _defineProperty(this, "linkLookup", null);
    _defineProperty(this, "showPreview", true);
    _defineProperty(this, "composerHeight", null);
    _initializerDefineProperty(this, "forcePreview", _descriptor12, this);
    _initializerDefineProperty(this, "whisperOrUnlistTopic", _descriptor13, this);
    _initializerDefineProperty(this, "categories", _descriptor14, this);
    _initializerDefineProperty(this, "topicModel", _descriptor15, this);
    _initializerDefineProperty(this, "isStaffUser", _descriptor16, this);
    _initializerDefineProperty(this, "whisperer", _descriptor17, this);
    _initializerDefineProperty(this, "canUnlistTopic", _descriptor18, this);
    _initializerDefineProperty(this, "isWhispering", _descriptor19, this);
  }
  get topicController() {
    return getOwnerWithFallback(this).lookup("controller:topic");
  }
  _setupPreview() {
    const val = this.site.mobileView ? false : this.keyValueStore.get("composer.showPreview") || "true";
    this.set("showPreview", val === "true");
  }
  get disableSubmit() {
    return this.model?.loading || this.isUploading || this.isProcessingUpload || this._disableSubmit;
  }
  set disableSubmit(value) {
    this.set("_disableSubmit", value);
  }
  get formTemplateIds() {
    if (!this.siteSettings.experimental_form_templates || this.skipFormTemplate) {
      return null;
    }
    return this.model?.category?.get("form_template_ids");
  }
  get hasFormTemplate() {
    return this.formTemplateIds?.length > 0 && !this.get("model.replyingToTopic") && !this.get("model.editingPost");
  }
  get formTemplateInitialValues() {
    return this._formTemplateInitialValues;
  }
  set formTemplateInitialValues(values) {
    this.set("_formTemplateInitialValues", values);
  }
  onSelectFormTemplate(formTemplate) {
    this.selectedFormTemplate = formTemplate;
  }
  toggleText(showPreview) {
    return showPreview ? I18n.t("composer.hide_preview") : I18n.t("composer.show_preview");
  }
  showPreviewChanged() {
    if (this.site.desktopView) {
      this.keyValueStore.set({
        key: "composer.showPreview",
        value: this.showPreview
      });
    }
  }
  focusTarget(replyingToTopic, creatingPM, usernames, composeState) {
    // Focus on usernames if it's blank or if it's just you
    usernames = usernames || "";
    if (creatingPM && usernames.length === 0 || usernames === this.currentUser.username) {
      return "usernames";
    }
    if (replyingToTopic) {
      return "reply";
    }
    if (composeState === Composer.FULLSCREEN) {
      return "editor";
    }
    return "title";
  }
  get showToolbar() {
    const keyValueStore = getOwnerWithFallback(this).lookup("service:key-value-store");
    const storedVal = keyValueStore.get("toolbar-enabled");
    if (this._toolbarEnabled === undefined && storedVal === undefined) {
      // iPhone 6 is 375, anything narrower and toolbar should
      // be default disabled.
      // That said we should remember the state
      this._toolbarEnabled = window.innerWidth > 370 && !this.capabilities.isAndroid;
    }
    return this._toolbarEnabled || storedVal === "true";
  }
  set showToolbar(val) {
    const keyValueStore = getOwnerWithFallback(this).lookup("service:key-value-store");
    this._toolbarEnabled = val;
    keyValueStore.set({
      key: "toolbar-enabled",
      value: val ? "true" : "false"
    });
  }
  canEditTags(canEditTitle, creatingPrivateMessage) {
    const isPrivateMessage = creatingPrivateMessage || this.get("model.topic.isPrivateMessage");
    return canEditTitle && this.site.can_tag_topics && (!isPrivateMessage || this.site.can_tag_pms);
  }
  disableCategoryChooser(editingPost, canEditTopic) {
    return editingPost && !canEditTopic;
  }
  disableTagsChooser(editingPost, canEditTags) {
    return editingPost && !canEditTags;
  }
  showWhisperToggle(canWhisper, replyingToWhisper) {
    return canWhisper && !replyingToWhisper;
  }
  replyingToWhisper(repliedToPost) {
    return repliedToPost && repliedToPost.post_type === this.site.post_types.whisper;
  }
  saveIcon(modelAction, isWhispering, privateMessage) {
    if (isWhispering) {
      return "far-eye-slash";
    }
    if (privateMessage && modelAction === Composer.REPLY) {
      return "envelope";
    }
    return SAVE_ICONS[modelAction];
  }

  // Note we update when some other attributes like tag/category change to allow
  // text customizations to use those.
  saveLabel(modelAction, isWhispering, editConflict, privateMessage) {
    let result = this.model.customizationFor("saveLabel");
    if (result) {
      return result;
    }
    if (editConflict) {
      return "composer.overwrite_edit";
    } else if (isWhispering) {
      return "composer.create_whisper";
    } else if (privateMessage && modelAction === Composer.REPLY) {
      return "composer.create_pm";
    }
    return SAVE_LABELS[modelAction];
  }
  canWhisper(whisperer, modelAction) {
    return whisperer && modelAction === Composer.REPLY;
  }
  _setupPopupMenuOption(option) {
    // Backwards compatibility support for when we used to accept a function.
    // This can be dropped when `addToolbarPopupMenuOptionsCallback` is removed from `plugin-api.js`.
    if (typeof option === "function") {
      option = option(this);
    }
    if (typeof option === "undefined") {
      return null;
    }
    const conditionType = typeof option.condition;
    if (conditionType === "undefined") {
      option.condition = true;
    } else if (conditionType === "boolean") {
      // uses existing value
    } else if (conditionType === "function") {
      option.condition = option.condition(this);
    } else {
      option.condition = this.get(option.condition);
    }
    return option;
  }
  disableTextarea(requiredCategoryMissing, replyLength) {
    return requiredCategoryMissing && replyLength === 0;
  }
  popupMenuOptions(composeState) {
    if (composeState === "open" || composeState === "fullscreen") {
      const options = [];
      options.push(this._setupPopupMenuOption({
        name: "toggle-invisible",
        action: "toggleInvisible",
        icon: "far-eye-slash",
        label: "composer.toggle_unlisted",
        condition: "canUnlistTopic"
      }));
      if (this.capabilities.touch) {
        options.push(this._setupPopupMenuOption({
          name: "format-code",
          action: "applyFormatCode",
          icon: "code",
          label: "composer.code_title"
        }));
        options.push(this._setupPopupMenuOption({
          name: "apply-unordered-list",
          action: "applyUnorderedList",
          icon: "list-ul",
          label: "composer.ulist_title"
        }));
        options.push(this._setupPopupMenuOption({
          name: "apply-ordered-list",
          action: "applyOrderedList",
          icon: "list-ol",
          label: "composer.olist_title"
        }));
      }
      options.push(this._setupPopupMenuOption({
        name: "toggle-whisper",
        action: "toggleWhisper",
        icon: "far-eye-slash",
        label: "composer.toggle_whisper",
        condition: "showWhisperToggle"
      }));
      options.push(this._setupPopupMenuOption({
        name: "toggle-spreadsheet",
        action: "toggleSpreadsheet",
        icon: "table",
        label: "composer.insert_table"
      }));
      return options.concat(customPopupMenuOptions.map(option => this._setupPopupMenuOption({
        ...option
      })).filter(o => o));
    }
  }
  showWarning(creatingPrivateMessage, usernames, warningsDisabled) {
    if (!this.get("currentUser.staff") || warningsDisabled) {
      return false;
    }
    const hasTargetGroups = this.get("model.hasTargetGroups");

    // We need exactly one user to issue a warning
    if (isEmpty(usernames) || usernames.split(",").length !== 1 || hasTargetGroups) {
      return false;
    }
    return creatingPrivateMessage;
  }
  draftTitle(topicTitle) {
    return emojiUnescape(escapeExpression(topicTitle));
  }
  allowUpload() {
    return authorizesOneOrMoreExtensions(this.currentUser.staff, this.siteSettings);
  }
  uploadIcon() {
    return uploadIcon(this.currentUser.staff, this.siteSettings);
  }
  ariaLabel(modelAction, isWhispering, privateMessage, postUsername) {
    switch (modelAction) {
      case "createSharedDraft":
        return I18n.t("composer.create_shared_draft");
      case "editSharedDraft":
        return I18n.t("composer.edit_shared_draft");
      case "createTopic":
        return I18n.t("composer.composer_actions.create_topic.label");
      case "privateMessage":
        return I18n.t("user.new_private_message");
      case "edit":
        return I18n.t("composer.composer_actions.edit");
      case "reply":
        if (isWhispering) {
          return `${I18n.t("composer.create_whisper")} ${this.site.get("whispers_allowed_groups_names")}`;
        }
        if (privateMessage) {
          return I18n.t("composer.create_pm");
        }
        if (postUsername) {
          return I18n.t("composer.composer_actions.reply_to_post.label", {
            postUsername
          });
        } else {
          return I18n.t("composer.composer_actions.reply_to_topic.label");
        }
      default:
        return I18n.t("keyboard_shortcuts_help.composing.title");
    }
  }

  // Use this to open the composer when you are not sure whether it is
  // already open and whether it already has a draft being worked on. Supports
  // options to append text once the composer is open if required.
  //
  // opts:
  //
  // - topic: if this is present, the composer will be opened with the reply
  // action and the current topic key and draft sequence
  // - fallbackToNewTopic: if true, and there is no draft and no topic,
  // the composer will be opened with the create_topic action and a new
  // topic draft key
  // - insertText: the text to append to the composer once it is opened
  // - openOpts: this object will be passed to this.open if fallbackToNewTopic is
  // true or topic is provided
  async focusComposer() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    await this._openComposerForFocus(opts);
    scheduleOnce("afterRender", this, this._focusAndInsertText, opts.insertText);
  }
  async _openComposerForFocus(opts) {
    if (this.get("model.viewOpen")) {
      return;
    }
    const opened = this.openIfDraft();
    if (opened) {
      return;
    }
    if (opts.topic) {
      return await this.open({
        action: Composer.REPLY,
        draftKey: opts.topic.get("draft_key"),
        draftSequence: opts.topic.get("draft_sequence"),
        topic: opts.topic,
        ...(opts.openOpts || {})
      });
    }
    if (opts.fallbackToNewTopic) {
      return await this.open({
        action: Composer.CREATE_TOPIC,
        draftKey: Composer.NEW_TOPIC_KEY,
        ...(opts.openOpts || {})
      });
    }
  }
  _focusAndInsertText(insertText) {
    document.querySelector("textarea.d-editor-input")?.focus();
    if (insertText) {
      this.model.appendText(insertText, null, {
        new_line: true
      });
    }
  }
  updateCategory(categoryId) {
    this.model.categoryId = categoryId;
  }
  openIfDraft(event) {
    if (!this.get("model.viewDraft")) {
      return false;
    }

    // when called from shortcut, ensure we don't propagate the key to
    // the composer input title
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.set("model.composeState", Composer.OPEN);
    document.documentElement.style.setProperty("--composer-height", this.get("model.composerHeight"));
    return true;
  }
  removeFullScreenExitPrompt() {
    this.set("model.showFullScreenExitPrompt", false);
  }
  async cancel(event) {
    event?.preventDefault();
    await this.cancelComposer();
  }
  cancelUpload(event) {
    event?.preventDefault();
    this.set("model.uploadCancelled", true);
  }
  togglePreview(event) {
    event?.preventDefault();
    this.toggleProperty("showPreview");
  }
  viewNewReply(event) {
    if (event && modKeysPressed(event).length > 0) {
      return false;
    }
    event?.preventDefault();
    DiscourseURL.routeTo(this.get("model.createdPost.url"));
    this.close();
  }
  closeComposer() {
    this.close();
  }
  onPopupMenuAction(menuItem) {
    // menuItem is an object with keys name & action like so: { name: "toggle-invisible, action: "toggleInvisible" }
    // `action` value can either be a string (to lookup action by) or a function to call
    this.appEvents.trigger("composer:toolbar-popup-menu-button-clicked", menuItem);
    if (typeof menuItem.action === "function") {
      return menuItem.action(this.toolbarEvent);
    } else {
      return (this.actions?.[menuItem.action]?.bind(this) ||
      // Legacy-style contributions from themes/plugins
      this[menuItem.action])();
    }
  }
  storeToolbarState(toolbarEvent) {
    this.set("toolbarEvent", toolbarEvent);
  }
  typed() {
    this.checkReplyLength();
    this.model.typing();
  }
  cancelled() {
    this.hitEsc();
  }
  addLinkLookup(linkLookup) {
    this.set("linkLookup", linkLookup);
  }
  afterRefresh(preview) {
    const topic = this.get("model.topic");
    const linkLookup = this.linkLookup;
    if (!topic || !linkLookup) {
      return;
    }

    // Don't check if there's only one post
    if (topic.posts_count === 1) {
      return;
    }
    const post = this.get("model.post");
    preview.querySelectorAll("a[href]").forEach(l => {
      const href = l.href;
      if (href && href.length) {
        // skip links added by watched words
        if (l.dataset.word !== undefined) {
          return;
        }

        // skip links in quotes and oneboxes
        for (let element = l; element; element = element.parentElement) {
          if (element.tagName === "DIV" && element.classList.contains("d-editor-preview")) {
            break;
          }
          if (element.tagName === "ASIDE" && element.classList.contains("quote")) {
            return;
          }
          if (element.tagName === "ASIDE" && element.classList.contains("onebox") && href !== element.dataset["onebox-src"]) {
            return;
          }
        }
        const [linkWarn, linkInfo] = linkLookup.check(post, href);
        if (linkWarn && !this.isWhispering) {
          if (linkInfo.username === this.currentUser.username) {
            this.appEvents.trigger("composer-messages:create", {
              extraClass: "custom-body",
              templateName: "education",
              body: I18n.t("composer.duplicate_link_same_user", {
                domain: linkInfo.domain,
                post_url: topic.urlForPostNumber(linkInfo.post_number),
                ago: shortDate(linkInfo.posted_at)
              })
            });
          } else {
            this.appEvents.trigger("composer-messages:create", {
              extraClass: "custom-body duplicate-link-message",
              templateName: "education",
              body: I18n.t("composer.duplicate_link", {
                domain: linkInfo.domain,
                username: linkInfo.username,
                post_url: topic.urlForPostNumber(linkInfo.post_number),
                ago: shortDate(linkInfo.posted_at)
              })
            });
          }
        }
      }
    });
  }
  toggleWhisper() {
    this.toggleProperty("model.whisper");
  }
  toggleSpreadsheet() {
    this.modal.show(SpreadsheetEditor, {
      model: {
        toolbarEvent: this.toolbarEvent,
        tableTokens: null
      }
    });
  }
  toggleInvisible() {
    this.toggleProperty("model.unlistTopic");
  }
  toggleToolbar() {
    this.toggleProperty("showToolbar");
  }

  // Toggle the reply view
  async toggle() {
    this.closeAutocomplete();
    const composer = this.model;
    if (isEmpty(composer?.reply) && isEmpty(composer?.title) && !this.hasFormTemplate) {
      this.close();
    } else if (composer?.viewOpenOrFullscreen) {
      this.shrink();
    } else {
      await this.cancelComposer();
    }
  }
  fullscreenComposer() {
    this.toggleFullscreen();
    return false;
  }

  // Import a quote from the post
  async importQuote(toolbarEvent) {
    const postStream = this.get("topic.postStream");
    let postId = this.get("model.post.id");

    // If there is no current post, use the first post id from the stream
    if (!postId && postStream) {
      postId = postStream.get("stream.firstObject");
    }

    // If we're editing a post, fetch the reply when importing a quote
    if (this.get("model.editingPost")) {
      const replyToPostNumber = this.get("model.post.reply_to_post_number");
      if (replyToPostNumber) {
        const replyPost = postStream.posts.findBy("post_number", replyToPostNumber);
        if (replyPost) {
          postId = replyPost.id;
        }
      }
    }
    if (!postId) {
      return;
    }
    this.set("model.loading", true);
    const post = await this.store.find("post", postId);
    const quote = buildQuote(post, post.raw, {
      full: true
    });
    toolbarEvent.addText(quote);
    this.set("model.loading", false);
  }
  saveAction(ignore, event) {
    this.save(false, {
      jump: !(event?.shiftKey && this.get("model.replyingToTopic")) && !this.skipJumpOnSave
    });
  }
  displayEditReason() {
    this.set("showEditReason", true);
  }
  hitEsc() {
    if (document.querySelectorAll(".emoji-picker-modal.fadeIn").length === 1) {
      this.appEvents.trigger("emoji-picker:close");
      return;
    }
    if ((this.messageCount || 0) > 0) {
      this.appEvents.trigger("composer-messages:close");
      return;
    }
    const composer = this.model;
    if (composer?.viewOpen) {
      this.shrink();
    }
    if (composer?.viewFullscreen) {
      this.toggleFullscreen();
      this.focusComposer();
    }
  }
  groupsMentioned(_ref) {
    let {
      name,
      userCount,
      maxMentions
    } = _ref;
    if (this.get("model.creatingPrivateMessage") || this.get("model.topic.isPrivateMessage")) {
      return;
    }
    maxMentions = parseInt(maxMentions, 10);
    userCount = parseInt(userCount, 10);
    let body;
    const groupLink = getURL(`/g/${name}/members`);
    if (userCount > maxMentions) {
      body = I18n.t("composer.group_mentioned_limit", {
        group: `@${name}`,
        count: maxMentions,
        group_link: groupLink
      });
    } else if (userCount > 0) {
      // Louder warning for a larger group.
      const translationKey = userCount >= 5 ? "composer.larger_group_mentioned" : "composer.group_mentioned";
      body = I18n.t(translationKey, {
        group: `@${name}`,
        count: userCount,
        group_link: groupLink
      });
    }
    if (body) {
      this.appEvents.trigger("composer-messages:create", {
        extraClass: "custom-body",
        templateName: "education",
        body
      });
    }
  }
  cannotSeeMention(_ref2) {
    let {
      name,
      reason,
      notifiedCount,
      isGroup
    } = _ref2;
    notifiedCount = parseInt(notifiedCount, 10);
    let body;
    if (isGroup) {
      body = I18n.t(`composer.cannot_see_group_mention.${reason}`, {
        group: name,
        count: notifiedCount
      });
    } else {
      body = I18n.t(`composer.cannot_see_mention.${reason}`, {
        username: name
      });
    }
    this.appEvents.trigger("composer-messages:create", {
      extraClass: "custom-body",
      templateName: "education",
      body
    });
  }
  hereMention(count) {
    this.appEvents.trigger("composer-messages:create", {
      extraClass: "custom-body",
      templateName: "education",
      body: I18n.t("composer.here_mention", {
        here: this.siteSettings.here_mention,
        count
      })
    });
  }
  applyFormatCode() {
    this.toolbarEvent.formatCode();
  }
  applyUnorderedList() {
    this.toolbarEvent.applyList("* ", "list_item");
  }
  applyOrderedList() {
    this.toolbarEvent.applyList(i => !i ? "1. " : `${parseInt(i, 10) + 1}. `, "list_item");
  }
  save(force) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (this.disableSubmit) {
      return;
    }

    // Clear the warning state if we're not showing the checkbox anymore
    if (!this.showWarning) {
      this.set("model.isWarning", false);
    }
    if (this.site.mobileView && this.showPreview) {
      this.set("showPreview", false);
    }
    if (this.hasFormTemplate) {
      const formTemplateData = prepareFormTemplateData(document.querySelector("#form-template-form"), this.selectedFormTemplate);
      if (formTemplateData) {
        this.model.set("reply", formTemplateData);
      } else {
        return;
      }
    }
    const composer = this.model;
    if (composer?.cantSubmitPost) {
      if (composer?.viewFullscreen) {
        this.toggleFullscreen();
      }
      this.set("lastValidatedAt", Date.now());
      return;
    }
    const topic = composer.topic;
    const slowModePost = topic && topic.slow_mode_seconds && topic.user_last_posted_at;
    const notEditing = this.get("model.action") !== "edit";

    // Editing a topic in slow mode is directly handled by the backend.
    if (slowModePost && notEditing) {
      if (cannotPostAgain(this.currentUser, topic.slow_mode_seconds, topic.user_last_posted_at)) {
        const canPostAt = new moment(topic.user_last_posted_at).add(topic.slow_mode_seconds, "seconds");
        const timeLeft = moment().diff(canPostAt, "seconds");
        const message = I18n.t("composer.slow_mode.error", {
          timeLeft: durationTextFromSeconds(timeLeft)
        });
        this.dialog.alert(message);
        return;
      } else {
        // Edge case where the user tries to post again immediately.
        topic.set("user_last_posted_at", new Date().toISOString());
      }
    }
    composer.set("disableDrafts", true);

    // for now handle a very narrow use case
    // if we are replying to a topic
    // AND are on a different topic
    // AND topic is open (or we are staff)
    // --> pop the window up
    if (!force && composer.replyingToTopic) {
      const currentTopic = this.topicModel;
      const originalTopic = this.model.topic;
      if (!currentTopic) {
        this.save(true);
        return;
      }
      const topicLabelContent = function (topicOption) {
        const topicClosed = topicOption.closed ? `<span class="topic-status">${iconHTML("lock")}</span>` : "";
        const topicPinned = topicOption.pinned ? `<span class="topic-status">${iconHTML("thumbtack")}</span>` : "";
        const topicBookmarked = topicOption.bookmarked ? `<span class="topic-status">${iconHTML("bookmark")}</span>` : "";
        const topicPM = topicOption.archetype === "private_message" ? `<span class="topic-status">${iconHTML("envelope")}</span>` : "";
        return `<div class="topic-title">
                  <div class="topic-title__top-line">
                    <span class="topic-statuses">
                      ${topicPM}${topicBookmarked}${topicClosed}${topicPinned}
                    </span>
                    <span class="fancy-title">
                      ${topicOption.fancyTitle}
                    </span>
                  </div>
                  <div class="topic-title__bottom-line">
                    ${categoryBadgeHTML(topicOption.category, {
          link: false
        })}${htmlSafe(renderTags(topicOption))}
                  </div>
                </div>`;
      };
      if (currentTopic.id !== composer.get("topic.id") && (this.isStaffUser || !currentTopic.closed)) {
        this.dialog.alert({
          title: I18n.t("composer.posting_not_on_topic"),
          buttons: [{
            label: topicLabelContent(originalTopic),
            class: "btn-primary btn-reply-where btn-reply-on-original",
            action: () => this.save(true)
          }, {
            label: topicLabelContent(currentTopic),
            class: "btn-reply-where btn-reply-here",
            action: () => {
              composer.setProperties({
                topic: currentTopic,
                post: null
              });
              this.save(true);
            }
          }, {
            label: I18n.t("composer.cancel"),
            class: "btn-flat btn-text btn-reply-where__cancel"
          }],
          class: "reply-where-modal"
        });
        return;
      }
    }
    let staged = false;

    // TODO: This should not happen in model
    const imageSizes = {};
    document.querySelectorAll("#reply-control .d-editor-preview img:not(.avatar, .emoji)").forEach(e => {
      const src = e.src;
      if (src && src.length) {
        imageSizes[src] = {
          width: e.naturalWidth,
          height: e.naturalHeight
        };
      }
    });
    const promise = composer.save({
      imageSizes,
      editReason: this.editReason
    }).then(result => {
      this.appEvents.trigger("composer:saved");
      if (result.responseJson.action === "enqueued") {
        this.postWasEnqueued(result.responseJson);
        if (result.responseJson.pending_post) {
          let pendingPosts = this.get("topicController.model.pending_posts");
          if (pendingPosts) {
            pendingPosts.pushObject(result.responseJson.pending_post);
          }
        }
        return this.destroyDraft().then(() => {
          this.close();
          this.appEvents.trigger("post-stream:refresh");
          return result;
        });
      }
      if (this.get("model.editingPost")) {
        this.appEvents.trigger("composer:edited-post");
        this.appEvents.trigger("post-stream:refresh", {
          id: parseInt(result.responseJson.id, 10)
        });
        if (result.responseJson.post.post_number === 1) {
          this.appEvents.trigger("header:update-topic", composer.topic);
        }
      } else {
        this.appEvents.trigger("post-stream:refresh");
      }
      if (result.responseJson.action === "create_post") {
        this.appEvents.trigger("composer:created-post");
        this.appEvents.trigger("post:highlight", result.payload.post_number, options);
      }
      if (this.get("model.draftKey") === Composer.NEW_TOPIC_KEY) {
        this.currentUser.set("has_topic_draft", false);
      }
      if (result.responseJson.route_to) {
        // TODO: await this:
        this.destroyDraft();
        if (result.responseJson.message) {
          return this.dialog.alert({
            message: result.responseJson.message,
            didConfirm: () => {
              DiscourseURL.routeTo(result.responseJson.route_to);
            }
          });
        }
        return DiscourseURL.routeTo(result.responseJson.route_to);
      }
      this.close();
      this.currentUser.set("any_posts", true);
      const post = result.target;
      if (post && !staged && options.jump !== false) {
        DiscourseURL.routeTo(post.url, {
          keepFilter: true,
          skipIfOnScreen: true
        });
      }
    }).catch(error => {
      composer.set("disableDrafts", false);
      if (error) {
        this.appEvents.one("composer:will-open", () => {
          if (_composerSaveErrorCallbacks.length === 0 || !_composerSaveErrorCallbacks.map(c => {
            return c.call(this, error);
          }).some(i => {
            return i;
          })) {
            this.dialog.alert(error);
          }
        });
      }
    });
    if (this.router.currentRouteName.split(".")[0] === "topic" && composer.get("topic.id") === this.get("topicModel.id")) {
      staged = composer.get("stagedPost");
    }
    this.appEvents.trigger("post-stream:posted", staged);
    this.messageBus.pause();
    promise.finally(() => this.messageBus.resume());
    return promise;
  }
  postWasEnqueued(details) {
    this.modal.show(PostEnqueuedModal, {
      model: details
    });
  }

  // Notify the composer messages controller that a reply has been typed. Some
  // messages only appear after typing.
  checkReplyLength() {
    if (!isEmpty("model.reply")) {
      this.appEvents.trigger("composer:typed-reply");
    }
  }

  /**
   Open the composer view
    @method open
   @param {Object} opts Options for creating a post
   @param {String} opts.action The action we're performing: edit, reply, createTopic, createSharedDraft, privateMessage
   @param {String} opts.draftKey
   @param {Post} [opts.post] The post we're replying to
   @param {Topic} [opts.topic] The topic we're replying to
   @param {String} [opts.quote] If we're opening a reply from a quote, the quote we're making
   @param {Boolean} [opts.ignoreIfChanged]
   @param {Boolean} [opts.disableScopedCategory]
   @param {Number} [opts.categoryId] Sets `scopedCategoryId` and `categoryId` on the Composer model
   @param {Number} [opts.prioritizedCategoryId]
   @param {Number} [opts.formTemplateId]
   @param {String} [opts.draftSequence]
   @param {Boolean} [opts.skipDraftCheck]
   @param {Boolean} [opts.skipJumpOnSave] Option to skip navigating to the post when saved in this composer session
   @param {Boolean} [opts.skipFormTemplate] Option to skip the form template even if configured for the category
   **/
  async open() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!opts.draftKey) {
      throw new Error("composer opened without a proper draft key");
    }
    let composerModel = this.model;
    if (opts.ignoreIfChanged && composerModel && composerModel.composeState !== Composer.CLOSED) {
      return;
    }
    this.setProperties({
      showEditReason: false,
      editReason: null,
      scopedCategoryId: null,
      prioritizedCategoryId: null,
      skipAutoSave: true
    });
    this.set("skipJumpOnSave", !!opts.skipJumpOnSave);
    this.set("skipFormTemplate", !!opts.skipFormTemplate);

    // Scope the categories drop down to the category we opened the composer with.
    if (opts.categoryId && !opts.disableScopedCategory) {
      const category = Category.findById(opts.categoryId);
      if (category) {
        this.set("scopedCategoryId", opts.categoryId);
      }
    }
    if (opts.prioritizedCategoryId) {
      const category = Category.findById(opts.prioritizedCategoryId);
      if (category) {
        this.set("prioritizedCategoryId", opts.prioritizedCategoryId);
      }
    }

    // If we want a different draft than the current composer, close it and clear our model.
    if (composerModel && opts.draftKey !== composerModel.draftKey && composerModel.composeState === Composer.DRAFT) {
      this.close();
      composerModel = null;
    }
    try {
      if (composerModel?.replyDirty) {
        // If we're already open, we don't have to do anything
        if (composerModel.composeState === Composer.OPEN && composerModel.draftKey === opts.draftKey && !opts.action) {
          return;
        }

        // If it's the same draft, just open it up again.
        if (composerModel.composeState === Composer.DRAFT && composerModel.draftKey === opts.draftKey) {
          composerModel.set("composeState", Composer.OPEN);

          // reset height set from collapse() state
          document.documentElement.style.setProperty("--composer-height", this.get("model.composerHeight"));
          if (!opts.action) {
            return;
          }
        }
        await this.cancelComposer(opts);
        await this.open(opts);
        return;
      }
      if (composerModel && composerModel.action !== opts.action) {
        composerModel.setProperties({
          unlistTopic: false,
          whisper: false
        });
      }

      // we need a draft sequence for the composer to work
      if (opts.draftSequence === undefined) {
        let data = await Draft.get(opts.draftKey);
        if (opts.skipDraftCheck) {
          data.draft = undefined;
        } else {
          data = await this.confirmDraftAbandon(data);
        }
        opts.draft ||= data.draft;
        opts.draftSequence = data.draft_sequence;
        await this._setModel(composerModel, opts);
        return;
      }

      // otherwise, do the draft check async
      if (!opts.draft && !opts.skipDraftCheck) {
        let data = await Draft.get(opts.draftKey);
        data = await this.confirmDraftAbandon(data);
        if (data.draft) {
          opts.draft = data.draft;
          opts.draftSequence = data.draft_sequence;
          await this.open(opts);
        }
      }
      await this._setModel(composerModel, opts);
    } finally {
      this.skipAutoSave = false;
      this.appEvents.trigger("composer:open", {
        model: this.model
      });
    }
  }
  async openNewTopic() {
    let {
      title,
      body,
      category,
      tags,
      formTemplate,
      preferDraft = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (preferDraft && this.currentUser.has_topic_draft) {
      return _assertClassBrand(_ComposerService_brand, this, _openNewTopicDraft).call(this);
    } else {
      return this.open({
        prioritizedCategoryId: category?.id,
        topicCategoryId: category?.id,
        formTemplateId: formTemplate?.id,
        topicTitle: title,
        topicBody: body,
        topicTags: tags,
        action: CREATE_TOPIC,
        draftKey: NEW_TOPIC_KEY,
        draftSequence: 0
      });
    }
  }
  async openNewMessage(_ref3) {
    let {
      title,
      body,
      recipients,
      hasGroups
    } = _ref3;
    return this.open({
      action: Composer.PRIVATE_MESSAGE,
      recipients,
      topicTitle: title,
      topicBody: body,
      archetypeId: "private_message",
      draftKey: Composer.NEW_PRIVATE_MESSAGE_KEY,
      hasGroups
    });
  }

  // Given a potential instance and options, set the model for this composer.
  async _setModel(optionalComposerModel, opts) {
    this.set("linkLookup", null);
    let composerModel;
    if (opts.draft) {
      composerModel = await loadDraft(this.store, opts);
      if (!composerModel) {
        throw new Error("draft was not found");
      }
    } else {
      const model = optionalComposerModel || this.store.createRecord("composer");
      await model.open(opts);
      composerModel = model;
    }
    this.set("model", composerModel);
    composerModel.setProperties({
      composeState: Composer.OPEN,
      isWarning: false,
      hasTargetGroups: opts.hasGroups,
      warningsDisabled: opts.warningsDisabled
    });
    if (!this.model.targetRecipients) {
      if (opts.usernames) {
        deprecated("`usernames` is deprecated, use `recipients` instead.", {
          id: "discourse.composer.usernames"
        });
        this.model.set("targetRecipients", opts.usernames);
      } else if (opts.recipients) {
        this.model.set("targetRecipients", opts.recipients);
      }
    }
    if (opts.topicTitle && opts.topicTitle.length <= this.siteSettings.max_topic_title_length) {
      this.model.set("title", opts.topicTitle);
    }
    if (opts.topicTags && this.site.can_tag_topics) {
      let tags = escapeExpression(opts.topicTags).split(",").slice(0, this.siteSettings.max_tags_per_topic);
      tags.forEach((tag, index, array) => array[index] = tag.substring(0, this.siteSettings.max_tag_length));
      this.model.set("tags", tags);
    }
    if (opts.topicBody) {
      this.model.set("reply", opts.topicBody);
    }
    if (opts.formTemplateId && this.model.get("category.form_template_ids")?.includes(opts.formTemplateId)) {
      this.model.set("formTemplateId", opts.formTemplateId);
    }
    if (opts.prependText && !this.model.reply?.includes(opts.prependText)) {
      this.model.prependText(opts.prependText, {
        new_line: true
      });
    }
    const defaultComposerHeight = this._getDefaultComposerHeight();
    this.set("model.composerHeight", defaultComposerHeight);
    document.documentElement.style.setProperty("--composer-height", defaultComposerHeight);
  }
  _getDefaultComposerHeight() {
    if (this.keyValueStore.getItem("composerHeight")) {
      return this.keyValueStore.getItem("composerHeight");
    }

    // The two custom properties below can be overridden by themes/plugins to set different default composer heights.
    if (this.model.action === "reply") {
      return "var(--reply-composer-height, 300px)";
    } else {
      return "var(--new-topic-composer-height, 400px)";
    }
  }
  async destroyDraft() {
    let draftSequence = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    const key = this.get("model.draftKey");
    if (!key) {
      return;
    }
    if (key === Composer.NEW_TOPIC_KEY) {
      this.currentUser.set("has_topic_draft", false);
    }
    if (this._saveDraftPromise) {
      await this._saveDraftPromise;
      return await this.destroyDraft();
    }
    const sequence = draftSequence || this.get("model.draftSequence");
    await Draft.clear(key, sequence);
    this.appEvents.trigger("draft:destroyed", key);
  }
  confirmDraftAbandon(data) {
    if (!data.draft) {
      return data;
    }

    // do not show abandon dialog if old draft is clean
    const draft = JSON.parse(data.draft);
    if (draft.reply === draft.originalText) {
      data.draft = null;
      return data;
    }
    if (!_checkDraftPopup) {
      data.draft = null;
      return data;
    }
    return new Promise(resolve => {
      this.dialog.alert({
        message: I18n.t("drafts.abandon.confirm"),
        buttons: [{
          label: I18n.t("drafts.abandon.yes_value"),
          class: "btn-danger",
          icon: "far-trash-alt",
          action: () => {
            this.destroyDraft(data.draft_sequence).finally(() => {
              data.draft = null;
              resolve(data);
            });
          }
        }, {
          label: I18n.t("drafts.abandon.no_value"),
          class: "btn-resume-editing",
          action: () => resolve(data)
        }]
      });
    });
  }
  cancelComposer() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.skipAutoSave = true;
    if (this._saveDraftDebounce) {
      cancel(this._saveDraftDebounce);
    }
    return new Promise(resolve => {
      if (this.get("model.hasMetaData") || this.get("model.replyDirty")) {
        const overridesDraft = this.model.composeState === Composer.OPEN && this.model.draftKey === opts.draftKey && [Composer.EDIT_SHARED_DRAFT, Composer.EDIT].includes(opts.action);
        const showSaveDraftButton = this.model.canSaveDraft && !overridesDraft;
        this.modal.show(DiscardDraftModal, {
          model: {
            showSaveDraftButton,
            onDestroyDraft: () => {
              return this.destroyDraft().then(() => {
                this.model.clearState();
                this.close();
              }).finally(() => {
                this.appEvents.trigger("composer:cancelled");
                resolve();
              });
            },
            onSaveDraft: () => {
              this._saveDraft();
              this.model.clearState();
              this.close();
              this.appEvents.trigger("composer:cancelled");
              return resolve();
            }
          }
        });
      } else {
        // it is possible there is some sort of crazy draft with no body ... just give up on it
        this.destroyDraft().then(() => {
          this.model.clearState();
          this.close();
        }).finally(() => {
          this.appEvents.trigger("composer:cancelled");
          resolve();
        });
      }
    }).finally(() => {
      this.skipAutoSave = false;
    });
  }
  unshrink() {
    this.model.set("composeState", Composer.OPEN);
    document.documentElement.style.setProperty("--composer-height", this.model.composerHeight);
  }
  shrink() {
    if (this.get("model.replyDirty") || this.get("model.canEditTitle") && this.get("model.titleDirty") || this.hasFormTemplate) {
      this.collapse();
    } else {
      this.close();
    }
  }
  _saveDraft() {
    if (!this.model) {
      return;
    }
    if (this.model.draftSaving) {
      this._saveDraftDebounce = discourseDebounce(this, this._saveDraft, 2000);
    } else {
      // This is a temporary solution to avoid losing the current form template state
      // until we have a proper draft system for these forms
      if (this.hasFormTemplate) {
        const form = document.querySelector("#form-template-form");
        if (form) {
          this.set("formTemplateInitialValues", getFormTemplateObject(form));
        }
      }
      this._saveDraftPromise = this.model.saveDraft(this.currentUser).finally(() => {
        this._lastDraftSaved = Date.now();
        this._saveDraftPromise = null;
      });
    }
  }
  _shouldSaveDraft() {
    if (this.model && !this.model.loading && !this.skipAutoSave && !this.model.disableDrafts) {
      if (!this._lastDraftSaved) {
        // pretend so we get a save unconditionally in 15 secs
        this._lastDraftSaved = Date.now();
      }
      if (Date.now() - this._lastDraftSaved > 15000) {
        this._saveDraft();
      } else {
        this._saveDraftDebounce = discourseDebounce(this, this._saveDraft, 2000);
      }
    }
  }
  categoryValidation(categoryId, lastValidatedAt) {
    if (!this.siteSettings.allow_uncategorized_topics && !categoryId) {
      return EmberObject.create({
        failed: true,
        reason: I18n.t("composer.error.category_missing"),
        lastShownAt: lastValidatedAt
      });
    }
  }
  tagValidation(category, tags, lastValidatedAt) {
    const tagsArray = tags || [];
    if (this.site.can_tag_topics && !this.currentUser.staff && category) {
      // category.minimumRequiredTags incorporates both minimum_required_tags, and required_tag_groups
      if (category.minimumRequiredTags > tagsArray.length) {
        return EmberObject.create({
          failed: true,
          reason: I18n.t("composer.error.tags_missing", {
            count: category.minimumRequiredTags
          }),
          lastShownAt: lastValidatedAt
        });
      }
    }
  }
  collapse() {
    this._saveDraft();
    this.set("model.composeState", Composer.DRAFT);
    document.documentElement.style.setProperty("--composer-height", "40px");
  }
  toggleFullscreen() {
    this._saveDraft();
    const composer = this.model;
    if (composer?.viewFullscreen) {
      composer?.set("composeState", Composer.OPEN);
    } else {
      composer?.set("composeState", Composer.FULLSCREEN);
      composer?.set("showFullScreenExitPrompt", true);
    }
  }
  showFullScreenPrompt(isFullscreen, showExitPrompt) {
    return isFullscreen && showExitPrompt && !this.capabilities.touch;
  }
  close() {
    // the 'fullscreen-composer' class is added to remove scrollbars from the
    // document while in fullscreen mode. If the composer is closed for any reason
    // this class should be removed

    const elem = document.querySelector("html");
    elem.classList.remove("fullscreen-composer");
    elem.classList.remove("composer-open");
    document.activeElement?.blur();
    document.documentElement.style.removeProperty("--composer-height");
    this.setProperties({
      model: null,
      lastValidatedAt: null
    });

    // This is a temporary solution to reset the saved form template state while we don't store drafts
    this.set("formTemplateInitialValues", undefined);
  }
  closeAutocomplete() {
    $(".d-editor-input").autocomplete({
      cancel: true
    });
  }
  canEdit(modelAction) {
    return modelAction === "edit" && this.currentUser.can_edit;
  }
  visible(state) {
    return state && state !== "closed";
  }
  clearLastValidatedAt() {
    this.set("lastValidatedAt", null);
  }
}), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "capabilities", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "dialog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "keyValueStore", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "messageBus", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "forcePreview", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "whisperOrUnlistTopic", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "categories", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "topicModel", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "isStaffUser", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "whisperer", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, "canUnlistTopic", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, "isWhispering", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "_setupPreview", [_dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "_setupPreview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disableSubmit", [_dec10], Object.getOwnPropertyDescriptor(_class2.prototype, "disableSubmit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "formTemplateIds", [_dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "formTemplateIds"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSelectFormTemplate", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onSelectFormTemplate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleText", [_dec12], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showPreviewChanged", [_dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "showPreviewChanged"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "focusTarget", [_dec14], Object.getOwnPropertyDescriptor(_class2.prototype, "focusTarget"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showToolbar", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showToolbar"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canEditTags", [_dec15], Object.getOwnPropertyDescriptor(_class2.prototype, "canEditTags"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disableCategoryChooser", [_dec16], Object.getOwnPropertyDescriptor(_class2.prototype, "disableCategoryChooser"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disableTagsChooser", [_dec17], Object.getOwnPropertyDescriptor(_class2.prototype, "disableTagsChooser"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showWhisperToggle", [_dec18], Object.getOwnPropertyDescriptor(_class2.prototype, "showWhisperToggle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "replyingToWhisper", [_dec19], Object.getOwnPropertyDescriptor(_class2.prototype, "replyingToWhisper"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "saveIcon", [_dec20], Object.getOwnPropertyDescriptor(_class2.prototype, "saveIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "saveLabel", [_dec21], Object.getOwnPropertyDescriptor(_class2.prototype, "saveLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canWhisper", [_dec22], Object.getOwnPropertyDescriptor(_class2.prototype, "canWhisper"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disableTextarea", [_dec23], Object.getOwnPropertyDescriptor(_class2.prototype, "disableTextarea"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "popupMenuOptions", [_dec24], Object.getOwnPropertyDescriptor(_class2.prototype, "popupMenuOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showWarning", [_dec25], Object.getOwnPropertyDescriptor(_class2.prototype, "showWarning"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "draftTitle", [_dec26], Object.getOwnPropertyDescriptor(_class2.prototype, "draftTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "allowUpload", [discourseComputed], Object.getOwnPropertyDescriptor(_class2.prototype, "allowUpload"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "uploadIcon", [_dec27], Object.getOwnPropertyDescriptor(_class2.prototype, "uploadIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "ariaLabel", [_dec28], Object.getOwnPropertyDescriptor(_class2.prototype, "ariaLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "focusComposer", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "focusComposer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateCategory", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "updateCategory"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "openIfDraft", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "openIfDraft"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeFullScreenExitPrompt", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "removeFullScreenExitPrompt"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cancel", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "cancel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cancelUpload", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "cancelUpload"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "togglePreview", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "togglePreview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "viewNewReply", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "viewNewReply"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "closeComposer", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "closeComposer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onPopupMenuAction", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onPopupMenuAction"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "storeToolbarState", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "storeToolbarState"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "typed", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "typed"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cancelled", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "cancelled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "addLinkLookup", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "addLinkLookup"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterRefresh", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "afterRefresh"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleWhisper", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleWhisper"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleSpreadsheet", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleSpreadsheet"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleInvisible", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleInvisible"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleToolbar", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleToolbar"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggle", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "toggle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "fullscreenComposer", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "fullscreenComposer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "importQuote", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "importQuote"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "saveAction", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "saveAction"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "displayEditReason", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "displayEditReason"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hitEsc", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "hitEsc"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "groupsMentioned", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "groupsMentioned"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cannotSeeMention", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "cannotSeeMention"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hereMention", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "hereMention"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "applyFormatCode", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "applyFormatCode"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "applyUnorderedList", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "applyUnorderedList"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "applyOrderedList", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "applyOrderedList"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "postWasEnqueued", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "postWasEnqueued"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "openNewTopic", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "openNewTopic"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "openNewMessage", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "openNewMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_shouldSaveDraft", [_dec29], Object.getOwnPropertyDescriptor(_class2.prototype, "_shouldSaveDraft"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "categoryValidation", [_dec30], Object.getOwnPropertyDescriptor(_class2.prototype, "categoryValidation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "tagValidation", [_dec31], Object.getOwnPropertyDescriptor(_class2.prototype, "tagValidation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showFullScreenPrompt", [_dec32], Object.getOwnPropertyDescriptor(_class2.prototype, "showFullScreenPrompt"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canEdit", [_dec33], Object.getOwnPropertyDescriptor(_class2.prototype, "canEdit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "visible", [_dec34], Object.getOwnPropertyDescriptor(_class2.prototype, "visible"), _class2.prototype)), _class2)) || _class);
async function _openNewTopicDraft() {
  if (this.model?.action === Composer.CREATE_TOPIC && this.model?.draftKey === Composer.NEW_TOPIC_KEY) {
    this.set("model.composeState", Composer.OPEN);
  } else {
    const data = await Draft.get(Composer.NEW_TOPIC_KEY);
    if (data.draft) {
      return this.open({
        action: Composer.CREATE_TOPIC,
        draft: data.draft,
        draftKey: Composer.NEW_TOPIC_KEY,
        draftSequence: data.draft_sequence
      });
    }
  }
}
export { ComposerService as default }; // For compatibility with themes/plugins which use `modifyClass` as if this is a controller
// https://api.emberjs.com/ember/5.1/classes/Service/properties/mergedProperties?anchor=mergedProperties
ComposerService.prototype.mergedProperties = ["actions"];